import{AccessibleIcon as c}from"radix-ui";const s=c.Root;export{s as AccessibleIcon};
//# sourceMappingURL=accessible-icon.js.map
